<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Formulários Dinâmicos</strong>
              <a
                v-permission="'PerguntaDinamica.Adicionar'"
                class="ml-auto btn btn-primary"
                href="/#/formulario-dinamico/novo"
                title="Adicionar novo formulário dinâmico"
              >
                Adicionar
              </a>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              empty-text="Nenhum formulário dinâmico encontrado."
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(questionType)="data">
                {{ tipoLabel(data.item.questionType) }}
              </template>
              <template v-slot:cell(isGaau)="data">
                <span v-if="data.item.isGaau" class="badge badge-info">
                  Gaau
                </span>
                <span v-else class="badge badge-secondary">Inventário</span>
              </template>
              <template v-slot:cell(isRequired)="data">
                <div class="center">
                  <span v-if="data.item.isRequired" class="badge badge-success">
                    Sim
                  </span>
                  <span v-else class="badge badge-secondary">Não</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                    variant="warning"
                    style="margin-right: 10px"
                    title="Editar"
                    @click="Editar(data.item)"
                    v-permission="'PerguntaDinamica.Editar'"

                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    title="Remover"
                    @click="Remover(data.item)"
                    v-permission="'PerguntaDinamica.Remover'"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão desse registro?
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import DynamicFormService from "../../servico/DynamicFormService";
import QuestionTypeEnum from "../../enums/QuestionTypeEnum";

const TIPOS = {
  [QuestionTypeEnum.ShortText]: "Texto Curto",
  [QuestionTypeEnum.LongText]: "Texto Longo",
  [QuestionTypeEnum.SingleChoice]: "Escolha Única",
  [QuestionTypeEnum.MultipleChoice]: "Múltipla Escolha",
  [QuestionTypeEnum.Dropdown]: "Lista Suspensa",
  [QuestionTypeEnum.Scale]: "Escala",
  [QuestionTypeEnum.Date]: "Data",
  [QuestionTypeEnum.Number]: "Número",
  [QuestionTypeEnum.Email]: "E-mail"
};

export default {
  name: "DynamicForm",
  components: {
    RotateSquare
  },
  data() {
    return {
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      fields: [
        { key: "title", label: "Título", sortable: true },
        { key: "questionType", label: "Tipo", sortable: true },
        { key: "isGaau", label: "Contexto", sortable: true },
        { key: "isRequired", label: "Obrigatório", sortable: true },
        { key: "order", label: "Ordem", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  beforeMount() {
    this.ObterGrid(1);
  },
  methods: {
    tipoLabel(tipo) {
      return TIPOS[tipo] || tipo;
    },
    Editar(item) {
      this.$router.push("/formulario-dinamico/editar/" + item.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      DynamicFormService.Remover(this.itemRemover.id)
        .then(() => {
          this.ObterGrid(1);
          this.$notify({
            data: ["Formulário dinâmico removido com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    ObterGrid(pagina) {
      this.loading = true;

      DynamicFormService.ObterGrid(pagina)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
